import { useRef, useEffect } from "react";
export function useInputFocus() {
    var field = useRef(null);
    useEffect(function () {
        var _a;
        (_a = field.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    return field;
}
